// Lo poco de Leaflet que usan nuestros mapas, tipado a mano: la librería se
// carga del CDN (hooks/useLeaflet) y no hay @types/leaflet. No pretende ser
// completo; si hace falta un método más, se agrega acá.
export type LatLng = [number, number];

export interface LLayer {
  addTo(target: LMap | LGroup): this;
  on(event: string, fn: (e: any) => void): this;
  bindTooltip(content: HTMLElement | string, options?: object): this;
  bringToFront?(): this;
}

export interface LGroup {
  addTo(map: LMap): this;
  clearLayers(): this;
  eachLayer(fn: (layer: LLayer) => void): this;
}

export interface LMap {
  setView(center: LatLng, zoom: number): LMap;
  fitBounds(bounds: unknown, options?: object): LMap;
  getZoom(): number;
  on(event: string, fn: (e: any) => void): LMap;
  once(event: string, fn: (e: any) => void): LMap;
  off(): LMap;
  remove(): LMap;
  project(latlng: LatLng, zoom: number): { x: number; y: number };
  hasLayer(layer: LGroup): boolean;
  removeLayer(layer: LGroup): LMap;
  // Interno de Leaflet, pero es la única forma de saber si hay un zoom animado en curso.
  _animatingZoom?: boolean;
}

export interface LeafletLite {
  map(el: HTMLElement, options?: object): LMap;
  tileLayer(url: string, options?: object): LLayer;
  layerGroup(): LGroup;
  circleMarker(latlng: LatLng, options?: object): LLayer;
  marker(latlng: LatLng, options?: object): LLayer;
  polygon(rings: LatLng[][], options?: object): LLayer;
  polyline(latlngs: LatLng[], options?: object): LLayer;
  divIcon(options: object): unknown;
  latLngBounds(points: LatLng[]): unknown;
}

export const leafletGlobal = (): LeafletLite | undefined => (window as any).L;
